export interface BarriersStateModel {
  rows: Barrier[];
  selectedLocation: string;
}
export interface Barrier {
  uuid: string;
  name: string;
  openingTime: string;
  closingTime: string;
}

export interface SendActionData {
  locationUuid: string;
  barrierUuid: string;
  actionType: ActionType;
}

export enum ActionType {
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
}
